import { Box, Text } from '@streamelements/frontend-ui';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { providerIcons } from '../../components/ProviderIcon';
import { AllowedProvider } from '../../constants/common';
import { z } from 'zod';

const searchParamsSchema = z
  .object({
    navigateTo: z.string().optional(),
  })
  .default({});

export const Route = createFileRoute('/auth/$provider/success')({
  component: SuccessPage,
  validateSearch: searchParamsSchema,
  loaderDeps: ({ search }) => {
    return search;
  },
  loader: async ({ deps: { navigateTo } }) => {
    if (!navigateTo) return;

    const url = new URL(decodeURIComponent(navigateTo), window.location.origin);
    const searchParams = Object.fromEntries(url.searchParams.entries());

    redirect({
      to: url.pathname,
      search: searchParams,
    });
  },
});

function SuccessPage() {
  const { provider } = Route.useParams();
  const Icon = providerIcons[provider as AllowedProvider];

  return (
    <Box
      css={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '1rem',
        height: '100vh',
        textAlign: 'center',
      }}
    >
      <Box css={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
        <Box as="img" src="/logo.png" css={{ width: '3.25rem' }} />
        <Box as="img" src="/handshake.png" css={{ width: '1.5rem' }} />
        <Icon size="xl" css={{ '&&': { fontSize: '2.5rem' } }}></Icon>
      </Box>
      <Text.Heading level={5} css={{ m: 0 }} weight="bold">
        Connection successful
      </Text.Heading>
      <Text.Body css={{ color: '$textPrimary70' }}>You can now close this window and return to SE.Live</Text.Body>
    </Box>
  );
}
